import { GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const updateMeetingInviteSliceReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<GreenroomInviteUserResponse & { sessionUuid: string }>) => {
    const { sessionUuid, ...updatedInvitee } = action.payload;
    if (state?.greenroomSessionMeetings?.[sessionUuid]?.invites) {
      let hasUpdated = false;
      state.greenroomSessionMeetings[sessionUuid].invites = state.greenroomSessionMeetings[sessionUuid].invites.map(
        (invitee) => {
          if (invitee.profile?.email === updatedInvitee?.profile?.email) {
            hasUpdated = true;
            return {
              ...invitee,
              ...updatedInvitee,
            };
          }
          return invitee;
        }
      );
      if (!hasUpdated) {
        state.greenroomSessionMeetings[sessionUuid].invites.push(updatedInvitee);
      }
    }
  });
};

export default updateMeetingInviteSliceReducer;
